export default "__VITE_ASSET__N8vLyiH___"